import { CHANGE_PASS_SUCCESS, CHANGE_PASS_FAIL } from "./types";

const user = JSON.parse(localStorage.getItem("vault_user"));

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

  export const systemReducer =(state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_PASS_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case CHANGE_PASS_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    default:
      return state;
  }
}
